/** axios--请求接口 */

/** 引入axios库 */
import Axios from 'axios'

import { MessageTime } from './Tool'

const service = Axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 12000,
    // headers: header
})
/** 请求拦截 */
service.interceptors.request.use(
    config => {
        let userInfo = JSON.parse(localStorage.getItem('username_2')) ;
        if(userInfo){
            config.headers['token'] = userInfo.token
        }
        config.headers['X-Frame-Options'] = 'SAMEORIGIN'
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)
/** 响应拦截 */
service.interceptors.response.use(
    response => {
        // if (response.status === 200) {
        //     return Promise.resolve(response.data)
        // } else {
        //     return Promise.reject(response.message, response)
        // }
        // console.log(response)
        if(response.data.code != 200){
            MessageTime('error', response.data.msg)
        }
        return response
    },
    error => {
        console.log(error)
        // if(error.response.data.code == 500) {
        //     MessageTime('error', error.response.data.msg)
        // } else if (error.response.data.code == 400) {
        //     MessageTime('error',error.response.data.msg)
        // } else if (error.response.data.code == 404) {
        //     MessageTime('error',error.response.data.msg)
        // }
        return Promise.reject(error)
    }
)

export default service;